import type { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Auth } from "@angular/fire/auth";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import { from } from "rxjs";
import { mergeMap } from "rxjs/operators";

export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const auth = inject(Auth);
    if (!isPropertyDefined(auth, "currentUser")) {
        return next(request);
    }

    return from(auth.currentUser.getIdToken()).pipe(
        mergeMap((token) => next(request.clone({ headers: request.headers.set("id-token", token) })))
    );
};
